import './../../styles/Modal.css';

function FontPreview({ fontName , onClose }) {
    const uniqueChars = `!@#$%^&*()_+-=[]{}|;:'",.<>?/`

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>
                    <span>×</span>
                    <span className="sr-only">Close modal</span>
                </button>
                <h1>Preview: {fontName}</h1>
                <div style={{ fontSize: 40, marginBottom: 20, wordBreak: 'break-all', fontFamily: fontName }}>
                    ABCDEFGHIJKLMNOPQRSTUVWXYZ<br />
                    abcdefghijklmnopqrstuvwxyz<br />
                    0123456789<br />
                    {uniqueChars}
                </div>
                <div style={{ fontSize: 48, wordBreak: 'break-all', fontFamily: fontName }}>
                    ABCDEFGHIJKLMNOPQRSTUVWXYZ<br />
                    abcdefghijklmnopqrstuvwxyz<br />
                    0123456789<br />
                    {uniqueChars}
                </div>
            </div>
        </div>
    );
}

export default FontPreview;